import { FormControl, FormErrorMessage, FormLabel, Input, Stack } from "@chakra-ui/react";
import { useSMSFormState } from "../SMSForm/hooks";
import { SyntheticEvent } from "react";
import { useB2pSMSFormStateReaction } from "./hooks";

export function B2pSMSForm() {
  const smsForm = useSMSFormState();
  useB2pSMSFormStateReaction();

  const handleChange = (e: SyntheticEvent<HTMLInputElement>) => {
    smsForm.setCode(e.currentTarget.value);
    smsForm.setErrorMessage("");
  };

  return (
    <Stack spacing={4}>
      <FormControl isInvalid={!!smsForm.errorMessage}>
        <FormLabel>
          Код из SMS
        </FormLabel>
        <Input
          name="otp"
          autoComplete="one-time-code"
          value={smsForm.code}
          maxLength={4}
          autoFocus
          onChange={handleChange}
          inputMode="numeric"
        />
        <FormErrorMessage>{smsForm.errorMessage}</FormErrorMessage>
      </FormControl>
    </Stack>
  );
}
